//导入vue中创建vue实例的方法
import {createApp} from 'vue'
//导入最大组件,以便加载其它组件内容
import App from './App.vue'
//导入自定义路由文件简写from './router'
import router from './router/router.js' //  ./ 同级目录 ../ 上级目录 @/ 根目录 src
//导入状态管理 './store'
import store from './store'
//导入全局通用css
import '@/assets/css/base.css'
//导入element-plus
import elementPlus from '@/plugins/element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//移入wow动画
import WOW from 'wow.js'
import 'wow.js/css/libs/animate.css'
//注册全局组件
import { registerGlobalComponents } from '@/components/components.js'
//导入全局样式
import '@/assets/styles/global.less'
//图片懒加载
import VueLazyLoad  from 'vue-lazyload'

//创建vue实例
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}

//是否打开动画
// const isOpenAnimate = ref(true)
// 创建 WOW 实例
const wowInstance = new WOW({
	boxClass: 'wow',               // 触发动画的类名
	animateClass: 'animated', // 动画类名
	offset: 0,                   // 滚动触发的偏移量
	mobile: true,                  // 是否在移动端启用动画
	live: true,                    // 是否对动态加载的元素应用动画
	resetAnimation: true            // 每次动画结束后重置动画状态
})
app.provide('wow', wowInstance)
// app.provide('isOpenAnimate', isOpenAnimate)
app.use(store)  // 注册状态管理
app.use(router) // 注册路由
app.use(registerGlobalComponents)
app.use(elementPlus)
app.mount('#app')
app.use(VueLazyLoad)
// 延迟初始化 WOW.js
wowInstance.init()





